import { useContext } from 'preact/hooks';

import { WidgetContext, type WidgetContextProps } from './WidgetContext';

export const useWidget = (): WidgetContextProps => {
  const context = useContext(WidgetContext);

  const {
    messages,
    setMessages,
    files,
    setFiles,
    widgetTitle,
    widgetTheme,
    widgetUuid,
    companyLogoSrc,
    editorLock,
    entryPointGateway,
    requirePhone,
    hasMaxUserPhone,
    setHasMaxUserPhone,
    setEditorLock,
    error,
    setError,
    hasNewMessage,
    setHasNewMessage,
    hideTriggerButton,
    locale,
    localeMessages,
  } = context;

  return {
    files,
    setFiles,
    messages,
    setMessages,
    widgetTitle,
    widgetTheme,
    widgetUuid,
    companyLogoSrc,
    editorLock,
    entryPointGateway,
    requirePhone,
    hasMaxUserPhone,
    setHasMaxUserPhone,
    setEditorLock,
    error,
    setError,
    hasNewMessage,
    setHasNewMessage,
    hideTriggerButton,
    locale,
    localeMessages,
  };
};
